import PropTypes from 'prop-types';
import React from 'react';
import { ItemCardSkeleton } from '../ItemCard/ItemCard';
import * as Ui from './ItemCardsGrid.styles';

const SKELETON_COUNT = 5;

const ItemCardsGrid = ({ items, isLoading, empty, children }) =>
  !isLoading && !items.length ? (
    empty
  ) : (
    <Ui.Grid>
      {isLoading
        ? Array.from({ length: SKELETON_COUNT }, (_, i) => <ItemCardSkeleton key={i} />)
        : children}
    </Ui.Grid>
  );

ItemCardsGrid.propTypes = {
  isLoading: PropTypes.bool,
  items: PropTypes.array.isRequired,
  empty: PropTypes.node,
  children: PropTypes.node,
};

export default ItemCardsGrid;
